(() => {
  const mount = () => {
    document.querySelectorAll('[data-oa-motion]').forEach(section => {
      const button = section.querySelector('.oa-motion-toggle');
      if (!button || button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const paused = section.dataset.paused !== 'true';
        section.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
        button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      });
    });
    document.querySelectorAll('[data-oa-klaviyo-trigger]').forEach(button => {
      if (button.dataset.klaviyoBound) return;
      button.dataset.klaviyoBound = 'true';
      button.addEventListener('click', () => {
        const formId = window.innerWidth < 768 ? button.dataset.formMobile : button.dataset.formDesktop;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    });
    const announcement = document.querySelector('.oa-ebf-announcement');
    if (announcement) document.documentElement.style.setProperty('--announcement-height', `${announcement.offsetHeight}px`);
  };
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
